<template>
  <div>
    <va-aside-layout :title="asideTitle">
      <base-material-card>
        <template v-slot:heading>
          <div class="display-2">
            {{ titleForm }}
          </div>
        </template>
        <point-form :id="id" :item="item" @saved="onSaved"></point-form>
      </base-material-card>
    </va-aside-layout>
    <base-material-card :title="title">
      <va-list
        ref="list"
        :filters="filters"
        disable-create-redirect
        @action="onAction"
      >
        <va-data-table
          :fields="fields"
          disable-create-redirect
          disable-edit-redirect
          @item-action="onAction"
        >
        </va-data-table>
      </va-list>
    </base-material-card>
  </div>
</template>

<script>
export default {
  props: ["resource", "title"],
  data() {
    return {
      filters: [
        "id",
        "description",
        { source: "coordinateX", type: "number" },
        { source: "coordinateY", type: "number" },
        { source: "coordinateZ", type: "number" },
        { source: "coordinateW", type: "number" },
        { source: "maps_id", type: "select" }
      ],
      fields: [
        { source: "id", sortable: true },
        { source: "description", sortable: true },
        { source: "coordinateX", type: "number", sortable: true },
        { source: "coordinateY", type: "number", sortable: true },
        { source: "coordinateZ", type: "number", sortable: true },
        { source: "coordinateW", type: "number", sortable: true },
        { source: "maps_id", type: "select", sortable: true }
      ],
      asideTitle: null,
      titleForm: null,
      id: null,
      item: null,
      show: false
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async onAction({ title, id, item }) {
      this.asideTitle = " ";
      this.titleForm = title;
      this.id = id;
     
      if (item != null) {
        this.item = item != null ? item : item;
      }
    },
    onSaved() {
      this.asideTitle = null;
      this.$refs.list.fetchData();
    }
  }
};
</script>
